import { createAction, props } from '@ngrx/store';
import { SubAccount } from './sub-accounts.state';

// Load Sub Accounts
export const loadSubAccounts = createAction('[Sub Accounts] Load Sub Accounts');

export const loadSubAccountsSuccess = createAction(
  '[Sub Accounts] Load Sub Accounts Success',
  props<{ subAccounts: SubAccount[] }>()
);

export const loadSubAccountsFailure = createAction(
  '[Sub Accounts] Load Sub Accounts Failure',
  props<{ error: string }>()
);

// Add Sub Account
export const addSubAccount = createAction(
  '[Sub Accounts] Add Sub Account',
  props<{ subAccount: SubAccount }>()
);

export const addSubAccountSuccess = createAction(
  '[Sub Accounts] Add Sub Account Success',
  props<{ subAccount: SubAccount }>()
);

export const addSubAccountFailure = createAction(
  '[Sub Accounts] Add Sub Account Failure',
  props<{ error: string }>()
);

// Update Sub Account
export const updateSubAccount = createAction(
  '[Sub Accounts] Update Sub Account',
  props<{ subAccount: SubAccount }>()
);

export const updateSubAccountSuccess = createAction(
  '[Sub Accounts] Update Sub Account Success',
  props<{ subAccount: SubAccount }>()
);

export const updateSubAccountFailure = createAction(
  '[Sub Accounts] Update Sub Account Failure',
  props<{ error: string }>()
);

// Remove Sub Account
export const removeSubAccount = createAction(
  '[Sub Accounts] Remove Sub Account',
  props<{ subAccountId: string }>()
);

export const removeSubAccountSuccess = createAction(
  '[Sub Accounts] Remove Sub Account Success',
  props<{ subAccountId: string }>()
);

export const removeSubAccountFailure = createAction(
  '[Sub Accounts] Remove Sub Account Failure',
  props<{ error: string }>()
);

// Clear Sub Accounts
export const clearSubAccounts = createAction(
  '[Sub Accounts] Clear Sub Accounts'
);
